// Module
var code = "<div> <span translate=\"title_working\"></span> </div>";
// Exports
var _module_exports =code;;
var path = '/views/cs-rotating-loading-msg.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;